import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import WalletManagementTable from './components/WalletManagementTable';
import { trans } from '../../../localization/index';
import {
  changeTableActivePage,
  changeTablePageSize,
  closeDialogGeneric,
} from '../../../redux/genericAction';
import { EnumPage, EnumTypeForm } from '../../../constants/enum';
import {
  addRestaurantUserWallet,
  changeTableActivePageWalletRestaurant,
  changeTablePageSizeWalletRestaurant,
  closeAddRestaurantUserWallet,
  closeUserWalletRestaurant,
  createUserWallet,
  getListUserWallet,
  getListUserWalletRestaurant,
  getUnLinkedRestaurant,
  openAddRestaurantUserWallet,
  openCreateUserWallet,
  openUpdateUserWallet,
  removeRestaurantUserWallet,
  resendActivationEmailUserWallet,
  setToggleOpenActiveEmail,
  updateUserWallet,
} from './actions';
import RestaurantWalletModal from './RestaurantWallet/RestaurantWalletModal';
import CreateWalletModal from './CreateWallet/CreateWalletModal';
import WalletManagementFilter from './components/WalletManagementFilter';
import UpdateWalletModal from './UpdateWallet/UpdateWalletModal';
import { setGeneralError } from '../../../layout/components/UniversalModal/actions';
import AddRestaurantWalletModal from './AddRestaurantWallet/AddRestaurantWalletModal';
import NotificationUserActiveEmailModal from './components/NotificationUserActiveEmailModal';

import './Wallet.scss';

class WalletManagement extends Component {
  componentDidMount() {
    const { getListUserWalletConnect } = this.props;

    getListUserWalletConnect();
  }

  render() {
    const {
      user,
      userWallet,
      getListUserWalletConnect,
      changeTablePageSizeConnect,
      changeTableActivePageConnect,
      getListUserWalletRestaurantConnect,
      closeUserWalletRestaurantConnect,
      closeDialogGenericConnect,
      openUpdateUserWalletConnect,
      openCreateUserWalletConnect,
      setGeneralErrorConnect,
      createUserWalletConnect,
      updateUserWalletConnect,
      resendActivationEmailUserWalletConnect,
      removeRestaurantUserWalletConnect,
      addRestaurantUserWalletConnect,
      openAddRestaurantUserWalletConnect,
      closeAddRestaurantUserWalletConnect,
      setToggleOpenActiveEmailConnect,
      changeTableActivePageWalletRestaurantConnect,
      changeTablePageSizeWalletRestaurantConnect,
    } = this.props;
    const { table, dialog, walletRestaurant } = userWallet;
    const {
      isOpenDialog,
      typeForm,
      unlinkedRestaurants,
      airpayStoreId,
      activeEmailUpdate,
      walletItem,
    } = dialog;
    return (
      <React.Fragment>
        <h2 className="title-page">{trans('merchant_wallet_management')}</h2>
        <WalletManagementFilter
          createUserWallet={openCreateUserWalletConnect}
        />
        <WalletManagementTable
          table={table}
          getList={getListUserWalletConnect}
          changePageSize={changeTablePageSizeConnect}
          changeActivePage={changeTableActivePageConnect}
          getListUserWalletRestaurant={getListUserWalletRestaurantConnect}
          openUpdateUserWallet={openUpdateUserWalletConnect}
          resendActivationEmailUserWallet={
            resendActivationEmailUserWalletConnect
          }
        />
        <RestaurantWalletModal
          walletRestaurant={walletRestaurant}
          closeUserWalletRestaurant={closeUserWalletRestaurantConnect}
          removeRestaurantUserWallet={removeRestaurantUserWalletConnect}
          openAddRestaurantUserWallet={openAddRestaurantUserWalletConnect}
          changeActivePage={changeTableActivePageWalletRestaurantConnect}
          changePageSize={changeTablePageSizeWalletRestaurantConnect}
        />
        <CreateWalletModal
          isOpenDialog={isOpenDialog && typeForm === EnumTypeForm.CREATE.id}
          closeDialogGeneric={closeDialogGenericConnect}
          unlinkedRestaurants={unlinkedRestaurants}
          setGeneralError={setGeneralErrorConnect}
          createUserWallet={createUserWalletConnect}
          user={user}
        />
        <UpdateWalletModal
          isOpenDialog={isOpenDialog && typeForm === EnumTypeForm.UPDATE.id}
          closeDialogGeneric={closeDialogGenericConnect}
          setGeneralError={setGeneralErrorConnect}
          updateUserWallet={updateUserWalletConnect}
          airpayStoreId={airpayStoreId}
          walletItem={walletItem}
        />
        <AddRestaurantWalletModal
          closeAddRestaurantUserWallet={closeAddRestaurantUserWalletConnect}
          setGeneralError={setGeneralErrorConnect}
          addRestaurantUserWallet={addRestaurantUserWalletConnect}
          walletRestaurant={walletRestaurant}
          unlinkedRestaurants={unlinkedRestaurants}
          user={user}
        />
        <NotificationUserActiveEmailModal
          activeEmailUpdate={activeEmailUpdate}
          closeActiveEmail={() => setToggleOpenActiveEmailConnect(false)}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  userWallet: state.wallet.userWallet,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => {
  const PAGE = EnumPage.WALLET_MANAGEMENT.id;
  return {
    changeTablePageSizeConnect: pageSize =>
      dispatch(changeTablePageSize(PAGE, pageSize)),
    changeTableActivePageConnect: activePage =>
      dispatch(changeTableActivePage(PAGE, activePage)),
    getListUserWalletConnect: () => dispatch(getListUserWallet()),
    getListUserWalletRestaurantConnect: (airpayStoreId) => {
      dispatch(getListUserWalletRestaurant(airpayStoreId));
    },
    closeUserWalletRestaurantConnect: () => {
      dispatch(closeUserWalletRestaurant());
    },
    closeDialogGenericConnect: () => {
      dispatch(closeDialogGeneric(PAGE));
    },
    openUpdateUserWalletConnect: (airpayStoreId, walletItem) => {
      dispatch(openUpdateUserWallet(airpayStoreId, walletItem));
    },
    openCreateUserWalletConnect: () => {
      dispatch(getUnLinkedRestaurant()).then(() => {
        dispatch(openCreateUserWallet());
      });
    },
    setGeneralErrorConnect: (message) => {
      dispatch(setGeneralError(message));
    },
    createUserWalletConnect: (reqData) => {
      dispatch(createUserWallet(reqData));
    },
    updateUserWalletConnect: (reqData) => {
      dispatch(updateUserWallet(reqData));
    },
    resendActivationEmailUserWalletConnect: (airpayStoreId, ownerEmail) => {
      dispatch(resendActivationEmailUserWallet(airpayStoreId, ownerEmail));
    },
    addRestaurantUserWalletConnect: (reqData) => {
      dispatch(addRestaurantUserWallet(reqData));
    },
    removeRestaurantUserWalletConnect: (reqData) => {
      dispatch(removeRestaurantUserWallet(reqData));
    },
    openAddRestaurantUserWalletConnect: () => {
      dispatch(getUnLinkedRestaurant()).then(() => {
        dispatch(openAddRestaurantUserWallet());
      });
    },
    closeAddRestaurantUserWalletConnect: () => {
      dispatch(closeAddRestaurantUserWallet());
    },
    setToggleOpenActiveEmailConnect: (isOpenDialog) => {
      dispatch(setToggleOpenActiveEmail(isOpenDialog));
    },
    changeTableActivePageWalletRestaurantConnect: (activePage) => {
      dispatch(changeTableActivePageWalletRestaurant(activePage));
    },
    changeTablePageSizeWalletRestaurantConnect: (pageSize) => {
      dispatch(changeTablePageSizeWalletRestaurant(pageSize));
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(WalletManagement),
);



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/WalletManagement.jsx